import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScore, Scores } from 'src/models/myscores.model';
import { Player } from 'src/models/player.model';
import { Score } from 'src/models/score.model';
import { UserService } from 'src/services/user.service';
import { DialogDoublesNameComponent } from '../dialogs/dialogChangeDoublesName.component';
import { PlayerService } from '../players/players.service';
import { ProfileService } from '../profile/profile.service';

export const REGISTRATION_OPEN = true;

@Component({
  selector: 'prelogin',
  templateUrl: './prelogin.component.html',
  styleUrls: ['prelogin.component.scss']
})
export class PreloginComponent implements OnInit {
  public busy: boolean = false;
  public player: Player = new Player();
  public scores: Scores = new Scores();
  public debug: boolean = false;
  public faTrash = faTrashAlt;
  public isTiebreakTourney: boolean = false;
  public avatar?: string;
  public ladderEnded: boolean = false;
  public REGISTRATION_OPEN: boolean = REGISTRATION_OPEN;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private router: Router, private playerSvc: PlayerService,
    private dialog: MatDialog,
    private profileSvc: ProfileService,
    private aRoute: ActivatedRoute) {
    //this.busy = true;

    //this.aRoute.queryParams.subscribe(params => this.debug = !!params.debug);
    // if (this.authorizeService.isAuthenticated()) {
    //   this.router.navigate(['home']);
    // }
  }

  // private isAuth(): Promise<boolean> {
  //   return new Promise((resolve, reject) => {
  //     this.authorizeService.isAuthenticated().subscribe(
  //       (bFlag: boolean) => {
  //         resolve(bFlag);
  //       },
  //       (err) => resolve(false)
  //     );
  //   });
  // }

  // TODO figure out how to NOT call these if user is not authenticated... HOWEVER, if(isAuthenticated) gets run only once here
  // so if the call above is delayed, this will never run!!!
  async ngOnInit() {
    // only call the user and player stuff if the user is logged in... otherwise, the error handler catches an error
    // and we do into an infinite loop. d'oh
    // this.isAuthenticated = await this.isAuth();
    // if (this.isAuthenticated) {
    //   const p1 = this.userSvc.getUser();
    //   const p2 = this.playerSvc.getScores();

    //   forkJoin([p1, p2]).subscribe(
    //     ([resp1, resp2]) => {
    //       this.player = new Player(resp1);
    //       this.isTiebreakTourney = this.player.ladderType == 'Tiebreak';
    //       // hardcode the first result when we are player one... because only one result will be returned
    //       // from the scores API when we request the main logged in player... (we get their ladder and level data)
    //       // --- as opposed to looking at someone ELSE where we get all their levels...
    //       this.scores = new Scores(resp2.results[0]);
    //       this.profileSvc.getAvatar(this.player.id).subscribe(
    //         (resp) => this.avatar = resp.base64img,
    //         (err) => console.log('no avatar found')
    //       );


    //       this.ladderEnded = this.scores.ladderEnded; // || (this.player.ladderId == '2022-1' && this.player.levelId == 16);


    //       this.busy = false;
    //     },
    //     (err) => {
    //       this.busy = false
    //       //console.error(err);
    //     }
    //   )
    // }
    // else this.busy = false;
  }
  // public delete(evt: any, id: number, name: string) {
  //   if (confirm(`Are you sure you want to delete this match/score against ${name}?`)) {
  //     this.http.delete(`/match/${id}`).subscribe(
  //       (resp) => {
  //         this.playerSvc.getScores().subscribe(
  //           (resp) => {
  //             this.scores.scores.length = 0;
  //             this.scores = new Scores(resp.results[0]);
  //           },
  //           (err) => console.error("unable to query scores")
  //         )
  //       },
  //       (err) => console.error(err)
  //     )
  //   }
  // }
  // public changeDoublesName(evt: any) {
  //   evt.preventDefault();
  //   const dialogConfig = new MatDialogConfig();
  //   const dRef = this.dialog.open(DialogDoublesNameComponent, dialogConfig);
  //   dRef.afterClosed().subscribe(
  //     (teamName: string) => this.player.doublesName = teamName
  //   )
  // }

  // public getCssClass(s: MyScore) {
  //   if (s.points >= 3) return 'win';
  //   if (s.score == 'FORFEIT' && s.points > 0) return 'win';

  //   //{ 'win': s.points == 3, 'loss': s.points < 3 }
  //   return 'loss';
  // }
}
